const Config = {
    apis: {
        backend: process.env.REACT_APP_BACKEND_ENDPOINT,
        google_recaptcha_site_key: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
    }
}

export default Config;
